import { Retailer, Session } from "types";

export const getSelectedDuration = (session: Session, retailer: Retailer) => {
  if (session.selected_duration !== null) return session.selected_duration;

  return Math.max(...retailer.duration_configurations.map(({ duration }) => duration));
};
